module.exports = __webpack_public_path__ + "8b94aeb9.svg";